// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2cgec","container":"styles_container__25gt2","title":"styles_title__379-G","wrapper":"styles_wrapper__j3LUW","answer":"styles_answer__1UGMk"};